import React, { useEffect, useState } from 'react'

import { InsertedPortal } from '../../controls/inserted_portal'
import { ArrowLeft, ArrowRight } from '../../images'
import {
  collectionScrollBox,
  dialogElement,
  isFirstInCollection,
} from './constants'

export const CarouselCollectionControls = () => {
  const [collectionIsScrollable, setCollectionIsScrollable] = useState(
    !!collectionScrollBox &&
      collectionScrollBox.scrollWidth > collectionScrollBox.clientWidth,
  )
  const [scrollLeft, setScrollLeft] = useState() // just used to rerender after scrolling

  useEffect(() => {
    const onScroll = () => {
      setScrollLeft(collectionScrollBox.scrollLeft)
    }
    collectionScrollBox.addEventListener('scroll', onScroll)

    return () => {
      collectionScrollBox.removeEventListener('scroll', onScroll)
    }
  }, [])

  useEffect(() => {
    if (!collectionScrollBox) {
      return
    }
    const onResize = () => {
      setCollectionIsScrollable(
        collectionScrollBox.scrollWidth >
          collectionScrollBox.clientWidth,
      )
    }
    const ro = new ResizeObserver(onResize)
    ro.observe(collectionScrollBox)

    return () => {
      ro.disconnect()
    }
  }, [])

  const previous = () => {
    const el = getNextCollectionElement(true)
    if (el) {
      el.scrollIntoView({ inline: 'end', behavior: 'smooth', block: 'nearest' })
    }
  }

  const next = () => {
    const el = getNextCollectionElement(false)
    if (el) {
      el.scrollIntoView({
        inline: 'start',
        behavior: 'smooth',
        block: 'nearest',
      })
    }
  }

  return (
    <>
      {isFirstInCollection && collectionIsScrollable && (
        <>
          {collectionScrollBox.scrollLeft !== 0 && (
            <InsertedPortal
              siblingElement={dialogElement}
              after={false}
            >
              <button
                style={{ ...nextButtonStyles, left: '0' }}
                onClick={previous}
              >
                <ArrowLeft width={'100%'} height={'100%'} />
              </button>
            </InsertedPortal>
          )}
          {collectionScrollBox.scrollLeft !==
            collectionScrollBox.scrollWidth -
              collectionScrollBox.clientWidth && (
            <InsertedPortal
              siblingElement={dialogElement}
              after={true}
            >
              <button
                style={{ ...nextButtonStyles, right: '0' }}
                onClick={next}
              >
                <ArrowRight width={'100%'} height={'100%'} />
              </button>
            </InsertedPortal>
          )}
        </>
      )}
    </>
  )
}

const getNextCollectionElement = (leftMarker = true) => {
  const widgets = Array.from(dialogElement.firstChild.childNodes).filter((n) =>
    n.hasAttribute('data-widget'),
  )
  const { left: parentLeft, right: parentRight } =
    collectionScrollBox.getBoundingClientRect()
  const length = Object.keys(widgets).length
  for (
    let i = leftMarker ? length - 1 : 0;
    leftMarker ? i >= 0 : i < length;
    leftMarker ? i-- : i++
  ) {
    const { left, right } = widgets[i].getBoundingClientRect()
    if (leftMarker && left < parentLeft) {
      return widgets[i]
    }
    if (!leftMarker && right >= parentRight) {
      return widgets[i]
    }
  }
}

const nextButtonStyles = {
  width: '35px',
  height: '35px',
  border: 'none',
  borderRadius: '50%',
  cursor: 'pointer',
  margin: '0 10px',
  position: 'absolute',
  top: '50%',
  zIndex: 1,
  transform: 'translateY(-50%)',
  padding: '7px',
}
